/**
 * Horizon-safe Variant Gate
 * - Forces user to select a size before Add to cart works
 * - Fixes the “S is preselected so clicking it does nothing” issue by clearing checked radios on load
 */
(function () {
  "use strict";

  const ALLOW_URL_VARIANT_TO_SKIP_GATE = true;

  function qs(sel, root = document) { return root.querySelector(sel); }
  function qsa(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  function hasUrlVariant() {
    try { return !!new URLSearchParams(window.location.search).get("variant"); }
    catch (e) { return false; }
  }

  function findScope(root) {
    return qs(".product-details", root) || qs("[data-product-details]", root) || root;
  }

  function findPicker(scope) {
    return qs("variant-picker", scope);
  }

  function findForm(scope) {
    return (
      qs('form[data-type="add-to-cart-form"]', scope) ||
      qs("form[action*='/cart/add']", scope) ||
      qs("product-form form", scope)
    );
  }

  function findATC(scope, form) {
    return (
      qs('button[type="submit"][name="add"]', form) ||
      qs('button[name="add"]', form) ||
      qs('button[type="submit"][name="add"]', scope) ||
      qs('button[name="add"]', scope)
    );
  }

  function setEnabled(btn, enabled) {
    if (!btn) return;
    if (enabled) {
      btn.removeAttribute("disabled");
      btn.setAttribute("aria-disabled", "false");
      btn.classList.remove("disabled", "is-disabled");
      btn.dataset.variantSelected = "true";
    } else {
      btn.setAttribute("disabled", "");
      btn.setAttribute("aria-disabled", "true");
      btn.classList.add("disabled");
      btn.dataset.variantSelected = "false";
    }
  }

  function setVariantId(form, variantId) {
    if (!form || !variantId) return;
    const idInput = qs('input[name="id"]', form);
    if (!idInput) return;
    if (idInput.value === String(variantId)) return;

    idInput.value = String(variantId);
    idInput.dispatchEvent(new Event("input", { bubbles: true }));
    idInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function clearCheckedRadios(picker) {
    const radios = qsa('input[type="radio"]', picker);
    radios.forEach((r) => {
      r.checked = false;
      r.removeAttribute("checked"); // IMPORTANT: removes server-rendered checked
    });
  }

  function gateOn(picker, btn, form) {
    picker.setAttribute("data-needs-selection", "true");
    picker.removeAttribute("data-user-selected");
    setEnabled(btn, false);

    // optional: clear hidden variant id so nothing can add without selection
    const idInput = form ? qs('input[name="id"]', form) : null;
    if (idInput) {
      idInput.value = "";
      idInput.dispatchEvent(new Event("input", { bubbles: true }));
      idInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function gateOff(picker, btn) {
    picker.removeAttribute("data-needs-selection");
    picker.setAttribute("data-user-selected", "true");
    setEnabled(btn, true);
  }

  function init(root = document) {
    const scope = findScope(root);
    const picker = findPicker(scope);
    if (!picker) return;

    const form = findForm(scope);
    const btn = findATC(scope, form);
    if (!form || !btn) return;

    const skipGate = ALLOW_URL_VARIANT_TO_SKIP_GATE && hasUrlVariant();

    if (!skipGate) {
      // KEY FIX: remove any preselected radio so first click on S triggers change
      clearCheckedRadios(picker);
      gateOn(picker, btn, form);
    } else {
      gateOff(picker, btn);
    }

    picker.addEventListener("change", (e) => {
      const t = e.target;
      if (!t || !t.matches('input[type="radio"]')) return;

      const variantId = t.getAttribute("data-variant-id");
      if (!variantId) return;

      // Let Horizon do its updates; we just ensure id + enable ATC
      queueMicrotask(() => {
        setVariantId(form, variantId);
        gateOff(picker, btn);
      });
    });

    form.addEventListener("submit", (e) => {
      if (picker.hasAttribute("data-needs-selection")) {
        e.preventDefault();
        e.stopImmediatePropagation();
        picker.style.animation = "shake 0.5s ease";
        setTimeout(() => (picker.style.animation = ""), 500);
      }
    }, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document));
  } else {
    init(document);
  }
  document.addEventListener("shopify:section:load", (e) => init(e.target));
})();
